export default __webpack_public_path__ + "static/rating-6561723fbfd40ce361190569d0746f9c.png";